import MobileEventCardCarousel from '../../components/mobile/MobileEventCardCarousel';
import MobileMap from '../../components/mobile/MobileMap';
import { useSearchFields } from '../../SearchFieldProvider';
import React, { useEffect, useState } from 'react'
import MobileSearchBar from '../../components/mobile/MobileSearchBar';
import MobileInputs from '../../components/mobile/MobileInputs';
import { useActiveSlide } from '../../ActiveSlideProvider';
import MobileEventList from '../../components/mobile/MobileEventList';

export default function MobileSearchResults({ events }) {
    const { activeSlide } = useActiveSlide();
    const { filter, showModal } = useSearchFields();
    const [eventsToPass, setEventsToPass] = useState(events);
    const [listView, setListView] = useState(false);

    useEffect(() => {
        setEventsToPass(filter(events));
    //eslint-disable-next-line
    }, [filter]);

    const carouselOrError = () => {
        if (eventsToPass.length > 0) {
            return (
                <div className="row align-items-stretch" >
                    <div className="d-block">
                        <MobileEventCardCarousel events={eventsToPass}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container py-3">
                    <h4>No events matched your search :/</h4>
                </div>
            );
        }
    };

    const goToList = () => {
        setListView(!listView);
    }

    if (!showModal) {
        if (!listView) {
            return (
                <div className="container" id="results">
                    <div className="d-flex row me-auto">
                        <div className="col">
                            <a href="/" aria-labelledby="Back button" role="button" type="button" className="btn">
                                <i className="fa fa-arrow-left" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div className="col-2 py-1">
                            <button type="button" className="btn btn-outline-dark" onClick={goToList}>List</button>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="d-block">
                            <MobileMap events={eventsToPass} zoom={15} height={"40vh"} centerEvent={eventsToPass[activeSlide]}/>
                        </div>
                    </div>
                    {carouselOrError()}
                    <nav className="navbar fixed-bottom" data-bs-theme="light">
                        <MobileSearchBar/>
                    </nav>
                </div>
            );
        } else {
            return (
                <MobileEventList events={eventsToPass} setListView={setListView}/>
            )
        }
        
    } else {
        return (
            <MobileInputs/>
        )
    }
    
}